// ============================================================
// SIMADCA v3.0 – App.tsx
// GateKeeper → AuthProvider → Router → Dashboard / Login
// ============================================================

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import roRO from 'antd/locale/ro_RO';

import GateKeeper   from './components/GateKeeper';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage    from './pages/LoginPage';
import Dashboard    from './pages/Dashboard';

// ─── Route guard ──────────────────────────────────────────

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <>{children}</>;
};

// ─── App interior (cu auth context disponibil) ─────────────

const AppInner: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/login" element={
        <PublicRoute><LoginPage /></PublicRoute>
      } />
      <Route path="/dashboard" element={
        <PrivateRoute><Dashboard /></PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </BrowserRouter>
);

// ─── App root ──────────────────────────────────────────────

const App: React.FC = () => (
  <ConfigProvider
    locale={roRO}
    theme={{
      token: {
        colorPrimary:    '#6366f1',
        borderRadius:    10,
        fontFamily:      "'Inter', sans-serif",
        colorBgContainer: '#ffffff',
      },
      components: {
        Button:  { borderRadius: 9 },
        Input:   { borderRadius: 9 },
        Select:  { borderRadius: 9 },
        Card:    { borderRadius: 14 },
        Modal:   { borderRadius: 18 },
        Table:   { borderRadius: 10 },
      },
    }}
  >
    {/* GateKeeper — primul strat, înainte de orice */}
    <GateKeeper>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </GateKeeper>
  </ConfigProvider>
);

export default App;